import React from "react";
import FuzzySearch from "fuzzy-search";
import Mousetrap from "mousetrap";

import arrayIdFinder from "../helpers/arrayIdFinder";

import DropZone from "./DropZone";
import Employee from "./Employee";

class LineManagerSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchBox: ""
    };
    this.fuzzy_search = new FuzzySearch(props.employeeDetails, ["name"]);
    Mousetrap.bind("escape", props.close);
  }
  render() {
    const { entityId, Graph, height, width, close } = this.props;

    const { searchBox } = this.state;
    const employees_filtered = this.fuzzy_search.search(searchBox);

    const employees = Graph.graphIdMapping[entityId].employees || [];
    const lineManager = employees.find(x => x.isLineManager)?.id;

    return (
      <DropZone height={height} width={width} Graph={Graph} entityId={entityId}>
        <div>
          <br />
          <div className="clearfix">
            <h2 className="float-left">Select Line Manager</h2>
            <h2
              onClick={close}
              className="float-right clickable"
              style={{ marginRight: "1em" }}
            >
              &#10006;
            </h2>
          </div>
          <div className="row">
            <div className="column column-25">
              <input
                value={searchBox}
                placeholder="Search"
                name="employee_search"
                onChange={e => this.setState({ searchBox: e.target.value })}
              />
            </div>
            <div className="column">
              <label className="label-inline" style={{ lineHeight: "3.8rem" }}>
                Drag employee(s) here to add to this entity
              </label>
            </div>
          </div>
          <div>
            {employees.map(e => {
              const employee = e ? arrayIdFinder(employees_filtered, e.id) : null;
              if (!employee) return null;
              return (
                <Employee
                  key={employee.id}
                  name={employee.name}
                  profile_pic={employee.profile_pic}
                  islineManager={employee.id === lineManager}
                  setLineManager={() =>
                    Graph.setLineManager(entityId, employee)
                  }
                  unsetLineManager={() =>
                    Graph.setLineManager(entityId, undefined)
                  }
                  removeEmployee={() =>
                    Graph.removeEmployee(entityId, employee)
                  }
                />
              );
            })}
          </div>
        </div>
      </DropZone>
    );
  }
}

export default LineManagerSelector;
